import * as components from './components'

export default [
  {
    path: '/asset/upload',
    component: components.AssetUpload,
    name: 'assetUpload',
    props: true
  },
  {
    path: '/scorm/upload',
    component: components.ScormUpload,
    name: 'scormUpload',
    props: true
  },
  {
    path: '/resource/create',
    component: components.AssetCreate,
    name: 'assetCreate',
    props: true
  },
  {
    path: '/resource/:uuid',
    component: components.AssetPreview,
    name: 'assetPreview',
    props: true
  },
  {
    path: '/resource/:uuid/edit',
    component: components.AssetEdit,
    name: 'assetEdit',
    props: true
  },
  {
    path: '/htmlResource/create',
    component: components.RichHtmlAssetCreate,
    name: 'htmlAssetCreate',
    props: true
  },
  {
    path: '/htmlResource/:uuid/edit',
    component: components.RichHtmlAssetCreate,
    name: 'htmlAssetEdit',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/learningContent/routes.js